export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "BroadwayFrameProvider.worker.js?f7a1a03974a752eb8953");
}
